import React, { useEffect, useState } from 'react';
import { Avatar } from '@mui/material';
import { Person as PersonIcon } from '@mui/icons-material';
import PatientProfileAvatar from '../PatientProfileAvatar';
import {
  loadCharacterProfilePictureLookup,
  profilePicturePersonaForCustomPatient,
} from '../../utils/customPatientProfilePicture';

function initialsFromName(name) {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return null;
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

const CustomPatientProfileAvatar = ({ patient, size = 40, sx }) => {
  const [lookup, setLookup] = useState(null);

  useEffect(() => {
    let cancelled = false;
    loadCharacterProfilePictureLookup()
      .then((map) => {
        if (!cancelled) setLookup(map);
      })
      .catch(() => {
        if (!cancelled) setLookup(new Map());
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const picturePersona = profilePicturePersonaForCustomPatient(patient, lookup);
  if (picturePersona) {
    return <PatientProfileAvatar persona={picturePersona} size={size} sx={sx} />;
  }

  const initials = initialsFromName(patient?.personal?.name);
  return (
    <Avatar
      alt=""
      sx={{
        width: size,
        height: size,
        bgcolor: 'primary.main',
        flexShrink: 0,
        fontSize: size >= 56 ? '1rem' : '0.875rem',
        ...sx,
      }}
    >
      {initials || <PersonIcon fontSize={size >= 56 ? 'large' : 'medium'} />}
    </Avatar>
  );
};

export default CustomPatientProfileAvatar;
